import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useVersionCheck } from "src/hooks/useVersionCheck";
import WhatsNewPopup from "src/components/WhatsNewPopup/WhatsNewPopup";
import "./updateBanner.scss";

// Dismiss state is intentionally in-memory only (never localStorage): dismissing
// in one tab must never suppress this banner in a different tab that's still
// running the old bundle.
export default function UpdateBanner() {
    const { t } = useTranslation();
    const { updateAvailable } = useVersionCheck();
    const [dismissed, setDismissed] = useState(false);
    const [showWhatsNew, setShowWhatsNew] = useState(false);

    if (!updateAvailable || dismissed) return null;

    return (
        <div className="update-banner">
            <span className="update-banner__label">{t("updateBanner.label")}</span>
            <span className="update-banner__text">{t("updateBanner.text")}</span>
            <button className="update-banner__whats-new" onClick={() => setShowWhatsNew(true)}>
                {t("whatsNew.button")}
            </button>
            <button className="update-banner__reload" onClick={() => window.location.reload()}>
                {t("updateBanner.reload")}
            </button>
            <button
                className="update-banner__dismiss"
                onClick={() => setDismissed(true)}
                aria-label={t("popup.close")}
            >
                ×
            </button>
            {showWhatsNew && <WhatsNewPopup onClose={() => setShowWhatsNew(false)} />}
        </div>
    );
}
